import React from "react";
import { ParserSubmission } from "../../../common/files/files.module";
import {
	getTenderParserSubmissionColor,
	getTenderParserSubmissionText,
} from "../tender.model";
import { If } from "../../../common/components/If";
import { Chip } from "@mui/material";

export interface ParserSubmissionStatusBadgeProps {
	readonly submission?: ParserSubmission;
}

export function ParserSubmissionStatusBadge(
	props: ParserSubmissionStatusBadgeProps
) {
	return (
		<If condition={getTenderParserSubmissionText(props.submission?.status)}>
			<Chip
				label={getTenderParserSubmissionText(props.submission?.status)}
				sx={{
					background: getTenderParserSubmissionColor(
						props.submission?.status
					),
					color: "white",
				}}
			/>
		</If>
	);
}
